import BaseSelect from 'components/Selects/BaseSelect/BaseSelect';
import { findSelectOption } from 'components/Selects/BaseSelect/utils/baseSelect.utils';
import { DeviceIsDeviceType } from 'features/Integrations/utils/deviceComparison.utils';
import { useState } from 'react';
import { Form } from 'react-bootstrap';
import { CARD_CLASS_NAMES } from '../../config/floodDeviceConfig';

export default function CopySettingsBar({ connectedDevices, setDeviceSettings, enabled }) {
  const [copyId, setCopyId] = useState(null);

  if (!enabled) return null;

  const copyFromOptions = connectedDevices
    .filter((node) => DeviceIsDeviceType(node, 'Stage'))
    .map((node) => ({
      value: String(node.id),
      label: (node.device_type !== 'Manual Road Closure' ? node.static_id + ' ' : '') + node.alias,
    }));

  return (
    <div className="d-flex flex-column flex-lg-row align-items-lg-center justify-content-between gap-2 bg-primary-shadow border border-1 border-black rounded-3 p-3">
      <div className="fw-semibold">Copy settings from</div>
      <BaseSelect
        wrapperClassName="flex-fill"
        isSearchable
        classNames={{ control: () => CARD_CLASS_NAMES.field }}
        selectProps={{
          'aria-label': 'Copy settings from',
          options: copyFromOptions,
          value: findSelectOption(copyFromOptions, copyId ?? ''),
          placeholder: 'Select device...',
          onChange: (option) => {
            const value = option?.value ?? '';
            if (!value) {
              setCopyId(null);
              return;
            }

            const selectedOption = connectedDevices.find(
              (node) => node.id === Number(value),
            )?.device_settings;

            setCopyId(value);

            if (!selectedOption) return;

            setDeviceSettings((prev) => ({
              ...prev,
              depthDet1: selectedOption.depthDet1,
              depthDet2: selectedOption.depthDet2,
              depthDet3: selectedOption.depthDet3,
              depthHoldHours: selectedOption.depthHoldHours,
              ffTheshold: selectedOption.ffTheshold,
              dropThresh: selectedOption.dropThresh,
              mode: selectedOption.mode,
              samp: selectedOption.samp,
              dDetImgEnable: selectedOption.dDetImgEnable,
              ffiImgEnable: selectedOption.ffiImgEnable ?? 0,
              dRateImgEnable: selectedOption.dRateImgEnable,
              hResImgEnable: selectedOption.hResImgEnable,
            }));
          },
        }}
      />
    </div>
  );
}
